/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_LabelInputs */

const en_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum gap (seconds)`)
};

const fr_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart minimal (secondes)`)
};

const de_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestlücke (Sekunden)`)
};

const it_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallo minimo (secondi)`)
};

const ru_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальный интервал (секунды)`)
};

const es_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hueco mínimo (segundos)`)
};

const zh_cn2_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小间隔（秒）`)
};

const ja_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小ギャップ（秒）`)
};

const hi_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम अंतराल (सेकंड)`)
};

const pt_pt2_ad_template_min_gap_label = /** @type {(inputs: Ad_Template_Min_Gap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo mínimo (segundos)`)
};

/**
* | output |
* | --- |
* | "Minimum gap (seconds)" |
*
* @param {Ad_Template_Min_Gap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_label = /** @type {((inputs?: Ad_Template_Min_Gap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_min_gap_label(inputs)
	if (locale === "de") return de_ad_template_min_gap_label(inputs)
	if (locale === "it") return it_ad_template_min_gap_label(inputs)
	if (locale === "ru") return ru_ad_template_min_gap_label(inputs)
	if (locale === "es") return es_ad_template_min_gap_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_min_gap_label(inputs)
	if (locale === "ja") return ja_ad_template_min_gap_label(inputs)
	if (locale === "hi") return hi_ad_template_min_gap_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_min_gap_label(inputs)
	return en_ad_template_min_gap_label(inputs)
});